<div [@serviceButtonEntering]="isLoaded" id="userProfileDetail" class="ya-typography"
  (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="description title-margin">
      <h2 langkey="phServiceCall_Title"></h2>
      <p langkey="phServiceCall_Description"></p>
    </div>
    <ng-container>
      <div class="menu-service-item-container">
        <ng-container *ngFor="let ServiceCall of ServiceCalls">
          <div a11y_Button class="choice ya-icon-button service-button left animate" (click)="OpenDialog(ServiceCall)">
            <div *ngIf="ServiceCall.last_image_update_at_ymd > 0" class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <div class="aspect-ration-img-box">
                  <img class="ya_image" [src]="ServiceCall.image_photo" rel="preload" alt="Image" />
                </div>
              </div>
            </div>
            <div
              [ngClass]="ServiceCall.last_image_update_at_ymd > 0 ? 'content-container' : 'content-container radius'">
              <h2 class="title">{{ServiceCall.label}}</h2>
              <span [ngClass]="ServiceCall.last_image_update_at_ymd > 0 ? 'visible-description' : '' "
                class="description-text description-text-ellipse">{{ServiceCall.description}}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>